import { useTranslation } from "react-i18next";

interface QuizProgressProps {
  progress: {
    tutorialProgress?: number;
    courseProgress?: number;
  } | null;
}

const QuizProgress = ({ progress }: QuizProgressProps) => {
  const { t } = useTranslation();

  if (!progress) {
    return null;
  }

  return (
    <div className="mt-6 sm:mt-8 p-4 sm:p-6 bg-gradient-to-r from-primary-50 to-primary-100 dark:from-primary-900/20 dark:to-primary-800/20 rounded-xl sm:rounded-2xl border border-primary-200/50 dark:border-primary-700/50">
      <h4 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-white mb-3 sm:mb-4 flex items-center">
        <svg
          className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-primary-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          />
        </svg>
        <span className="text-sm sm:text-base">Learning Progress</span>
      </h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        <div className="bg-white dark:bg-gray-800 p-3 sm:p-4 rounded-lg sm:rounded-xl border border-primary-200/50 dark:border-primary-700/50">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs sm:text-sm font-medium text-gray-600 dark:text-gray-400">
              {t("courses.tutorialProgress")}
            </span>
            <span className="text-base sm:text-lg font-bold text-primary-600 dark:text-primary-400">
              {progress.tutorialProgress || 0}%
            </span>
          </div>
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
            <div
              className="bg-gradient-to-r from-primary-400 to-primary-600 h-2 rounded-full transition-all duration-500"
              style={{
                width: `${progress.tutorialProgress || 0}%`,
              }}
            ></div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 p-3 sm:p-4 rounded-lg sm:rounded-xl border border-primary-200/50 dark:border-primary-700/50">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs sm:text-sm font-medium text-gray-600 dark:text-gray-400">
              {t("courses.courseProgress")}
            </span>
            <span className="text-base sm:text-lg font-bold text-primary-600 dark:text-primary-400">
              {progress.courseProgress || 0}%
            </span>
          </div>
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
            <div
              className="bg-gradient-to-r from-primary-400 to-primary-600 h-2 rounded-full transition-all duration-500"
              style={{
                width: `${progress.courseProgress || 0}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizProgress;
